"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["width", "height", "color"];

/**
 * Arrow dropdown icon component for dropdown triggers and expandable sections
 * Tree-shakeable icon component that only bundles when imported
 */
var ArrowDropdown = function ArrowDropdown(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M7 10L12 15L17 10H7Z",
    fill: color
  }));
};

var _default = ArrowDropdown;
exports.default = _default;